import styled from 'styled-components'

import { MaxWidthGrid } from 'Layout'
import { PRIMARY_NORMAL_COLOR, SECONDARY_LIGHTER_COLOR } from '@CSSVars/colors'

export const _SiteMap = styled.main` 
`

export const _HeroTitle = styled.h2`
  max-width: 100%;
  text-align: center;
  color: white;
  font-size: 26px;
  font-weight: 400;
`

export const _Main = styled(MaxWidthGrid)`
    h1 {
      width: 100%;
      padding: .5rem;
      font-size: 26px;
      font-weight: 400;
      border-bottom: 2px solid white;

      a {
        font-size: 26px;
        font-weight: 400;
        color: ${SECONDARY_LIGHTER_COLOR};
        &:hover {
          color: ${PRIMARY_NORMAL_COLOR};
        }
      }
    }
`
